export const getGradeBackgroundColor = (grade) => {
  switch (true) {
    case grade === -1:
      return "bg-default-200 text-gray-400";
    case grade < 5:
      return "bg-grade-low/[0.1] text-grade-low";
    case grade >= 5 && grade < 7:
      return "bg-grade-medium/[0.1] text-grade-medium";
    case grade >= 7:
      return "bg-grade-high/[0.1] text-grade-high";
    default:
      return "bg-default-200 text-gray-400";
  }
};

export const getChartGradientColor = (
  ctx,
  chart_area,
  type = "horizontal",
  start_color = "rgba(250, 76, 152, 1)",
  middle_color = "rgba(125, 77, 254, 1)",
  end_color = "rgba(67, 24, 255, 0.2)"
) => {
  const chartWidth = chart_area.right - chart_area.left;
  const chartHeight = chart_area.bottom - chart_area.top;
  let gradient = ctx.createLinearGradient(0, 0, chartWidth, chartHeight);
  if (type === "vertical") {
    gradient = ctx.createLinearGradient(0, chart_area.top, 0, chart_area.bottom);
  }
  if (start_color) {
    gradient.addColorStop(0, start_color);
  }
  gradient.addColorStop(0.5, middle_color);
  gradient.addColorStop(1, end_color);
  return gradient;
};
